import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

import { fetchData } from '../../../helpers/methods';
import { isValidEmail } from '../../../helpers/form-validation';

import Button from '../../../component-library/button';
import SpinnerContainer from '../../../component-library/spinner-container';
import FormField from '../../../component-library/form-field';
import FormItem from './sub-components-kp/form-item';
import Tile from '../../../component-library/tile';

const RegisterForAccessForm = () => {
	const { data, uiMenuConfig } = useOutletContext();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [conversationId, setConversationId] = useState('');
	const [formData, setFormData] = useState([]);
	const [message, setMessage] = useState('I would like to request access to this API');
	const [messageError, setMessageError] = useState('');
	const [disableSubmit, setDisableSubmit] = useState(false);
	const [showSuccess, setShowSuccess] = useState(false);
	const maxCommentLength = 512;

	const handleChange = (index, value) => {
		const newFormData = [
			...formData,
		];
		newFormData[index].value = value;
		setFormData(newFormData);
	};

	const handleMultiSelectChange = (index, value) => {
		const newArray = Array.from(value, newItem => newItem.value);
		const newFormData = [
			...formData,
		];
		newFormData[index].value = newArray;
		setFormData(newFormData);
	};

	const handleMessageChange = value => {
		setMessage(value);
	};

	const getConversationId = () => {
		fetchData({
			uri: `/api/web/asks/catitem/${data.id}?pageSize=0`,
			method: 'GET',
		})
			.then(res => {
				const newConversationId = res.body.conversations[0].conversation.key;
				setConversationId(newConversationId);
			});
	};

	const handleSubmit = () => {
		const newItems = [];
		formData.forEach(item => {
			if (item.type !== 'subheading') {
				const newItem = {
					label: item.label,
					value: item.value,
					id: item.id,
				};
				newItems.push(newItem);
			}
		});
		const commentData = {
			message,
			styling: 'request',
			template: 'default',
			templatedData: {
				items: newItems,
			},
		};
		fetchData({
			uri: `/api/web/asks/catitem/${data.id}/conv/${conversationId}`,
			method: 'POST',
			options: {
				body: JSON.stringify(commentData),
			},
		})
			.then(({ ok }) => {
				if (ok) {
					setShowSuccess(true);
					setDisableSubmit(false);
				} else {
					setError('Sorry, your request could not be sent at this time, please try again.');
					setDisableSubmit(false);
				}
			})
			.catch(() => {
				setError('Sorry, your request could not be sent at this time, please try again.');
				setDisableSubmit(false);
			});
	};

	const handleValidation = () => {
		setDisableSubmit(true);
		let NewError = false;
		const newFormData = [];
		if (message === '') {
			NewError = true;
			setMessageError('You must add a message.');
		}
		if (message.length > maxCommentLength) {
			NewError = true;
			setMessageError(`Message must be less than ${maxCommentLength} characters in length.`);
		}
		formData.forEach(item => {
			if (item.required === true && item.type !== 'email' && item.value === '') {
				NewError = true;
				const newItem = {
					...item,
					error: 'This is a required field.',
				};
				newFormData.push(newItem);
			} else if (item.required === true && item.type === 'email') {
				if (!isValidEmail(item.value)) {
					NewError = true;
					const newItem = {
						...item,
						error: 'Must be a valid email address.',
					};
					newFormData.push(newItem);
				} else {
					const newItem = {
						...item,
						error: '',
					};
					newFormData.push(newItem);
				}
			} else {
				const newItem = {
					...item,
					error: '',
				};
				newFormData.push(newItem);
			}
		});
		if (NewError === true) {
			setFormData(newFormData);
			setDisableSubmit(false);
		} else {
			setFormData(newFormData);
			handleSubmit();
		}
	};

	const getData = () => {
		fetchData({
			uri: '/api/web/asks/template/default',
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					const newFormData = body.items;
					setFormData(newFormData);
					setLoading(false);
				} else {
					setLoading(false);
				}
			})
			.catch(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		getData();
		getConversationId();
	}, []);

	return (
		<>
			<h3>{uiMenuConfig?.registerForAccess?.label || 'Register for Access'}</h3>
			{loading && (
				<SpinnerContainer />
			)}
			{showSuccess && (
				<Tile className="margin-bottom-24">
					<p><strong>Your access request has been submitted.</strong></p>
					<p>
						Thank you for submitting your request, the provider will be in touch shortly.
						You can find updates to your request in the &rsquo;Contact Provider&rsquo; section.
					</p>
				</Tile>
			)}
			{(!loading && !showSuccess) && (
				<Tile className="margin-bottom-24">
					<p>To get access to this API please use the form below.</p>
					<div className="border-bottom">
						<FormField
							label="Message"
							type="text"
							action={e => { handleMessageChange(e.target.value); }}
							id="message"
							name="message"
							value={message}
							required
							error={messageError}
							fullWidth
						/>
					</div>
					{formData?.length ? (
						<>
							<div className="get-api-access__form-row-2-col">
								{formData.map((field, index) => (
									<FormItem
										// eslint-disable-next-line react/no-array-index-key
										key={index}
										field={field}
										index={index}
										hasOauth={false}
										handleChange={(idx, value) => handleChange(idx, value)}
										handleMultiSelectChange={
											(idx, options) => handleMultiSelectChange(idx, options)
										}
										setShowRefDataSearchModal={() => {}}
									/>
								))}
							</div>
							{error && (
								<p className="font-color-theme-danger">{error}</p>
							)}
							<div className="text-right">
								<Button
									type="primary"
									label="Submit"
									onClick={() => handleValidation()}
									isDisabled={disableSubmit}
								/>
							</div>
						</>
					) : (
						<p className="grey-text margin-top-16">
							No form fields have been configured.
						</p>
					)}
				</Tile>
			)}
		</>
	);
};

export default RegisterForAccessForm;
